import React, { useEffect, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';

import { usePokCore } from '../../../common/hooks/usePokCore';
import { DragNDropFile } from '../../../common/components/File/DragNDropFiles';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { useNotifications } from '../../../common/hooks/useNotifications';
import { AttachmentObjectType } from '../../../common/pokCore/validation/enums';

import { EmailTextSubjectEditor } from './EmailTextSubjectEditor';
import { CustomEmailDataInfo } from './CustomEmailDataInfo';

interface CustomEmailDataLinkProps {
  invoiceId: string;
  emailText?: string | null;
  emailSubject?: string | null;
  hasAttachments?: boolean;
  refresh: boolean;
  setRefresh: (refresh: boolean) => void;
}

export const CustomEmailDataLink: React.FC<
  CustomEmailDataLinkProps
> = props => {
  const [show, setShow] = useState(false);
  const [myAttachments, setMyAttachments] = useState<DragNDropFile[]>([]);
  const pok = usePokCore();
  const notifications = useNotifications();
  const { t, tk } = useTranslation('fvsLng');

  const customEmailData =
    props.emailText || props.emailSubject || props.hasAttachments;

  const handleClick = () => {
    setShow(true);
  };

  const handleClose = () => {
    props.setRefresh(!props.refresh);
    setShow(false);
  };

  useEffect(() => {
    if (show) {
      pok.attachments
        .getAttachmentsInfoWithSizeForObjects(
          [props.invoiceId],
          AttachmentObjectType.SalesInvoice,
        )
        .then(attachments => {
          const myFiles: DragNDropFile[] = attachments.map(attachment => {
            return {
              id: attachment.id,
              name: attachment.name || '',
              size: attachment.fileSize || 0,
            };
          });
          setMyAttachments(myFiles);
        })
        .catch(err => {
          notifications.caughtError(err);
        });
    }
  }, [notifications, pok.attachments, props.invoiceId, show]);

  return (
    <>
      <div className="d-flex align-items-center gap-2">
        <OverlayTrigger
          overlay={
            <Tooltip>
              {customEmailData
                ? t(tk.sendEmail.editEmailTextSubject)
                : t(tk.sendEmail.addEmailTextSubject)}
            </Tooltip>
          }
        >
          <Button
            className="p-0"
            onClick={e => {
              e.stopPropagation();
              handleClick();
            }}
            variant="btn-info"
          >
            {customEmailData ? (
              <Icon.PencilFill className="icon-green" />
            ) : (
              <Icon.PlusCircleFill className="icon-green" />
            )}
          </Button>
        </OverlayTrigger>
        <CustomEmailDataInfo
          emailText={props.emailText}
          emailSubject={props.emailSubject}
          hasAttachments={props.hasAttachments}
        />
      </div>

      <EmailTextSubjectEditor
        show={show}
        onClose={handleClose}
        invoiceId={props.invoiceId}
        emailText={props.emailText}
        emailSubject={props.emailSubject}
        existingFiles={myAttachments}
      />
    </>
  );
};
